import { __rest } from 'tslib';
import React, { useRef } from 'react';
import { Box } from 'reflexbox';
import { Tooltip } from './Tooltip.es.js';

const TooltipUncontrolled = (_a) => {
    var { as, trigger, content, placement } = _a, props = __rest(_a, ["as", "trigger", "content", "placement"]);
    const ref = useRef(null);
    const [isVisible, setVisibility] = React.useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, Object.assign({ ref: ref, as: as, onMouseEnter: () => setVisibility(true), onMouseLeave: () => setVisibility(false) }, props), trigger),
        React.createElement(Tooltip, { isVisible: isVisible, referenceElement: ref, placement: placement },
            React.createElement(Box, { width: "fit-content" }, content))));
};

export { TooltipUncontrolled };
